'use client'

import { useContext } from 'react'

import { Avatar } from '@/components/avatar/avatar'
import { Text } from '@/components/Text/Text'
import { ThemeContext } from '@/utils/themeContext'
import { twist } from '@/Theme'

import css from './Author.module.css'

export interface AuthorTypes {
    name?: string
    role?: string
    resource?: string
    image: { src: string; alt?: string }
}

export function Author({ name, role, image, resource }: AuthorTypes) {
    const { theme } = useContext(ThemeContext)
    const { src, alt } = image

    return (
        <div className={css.author}>
            {resource ? (
                <Text className={css.by} size="minor-xs">
                    {resource}
                </Text>
            ) : null}

            <div className={css.copyWrapper}>
                <div className={css.avatar}>
                    <Avatar size={50} src={src} alt={alt} />
                </div>
                <div>
                    {name ? (
                        <Text
                            tag="p"
                            size="minor-base"
                            weight={theme === twist ? 'bold' : undefined}
                        >
                            {name}
                        </Text>
                    ) : null}
                    {role ? (
                        <Text tag="p" size="body-xs">
                            {role}
                        </Text>
                    ) : null}
                </div>
            </div>
        </div>
    )
}
